import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function UntouchableIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4182" data-mp="38j05cx591szj">
      <div className="relative w-full h-full bg-gradient-to-br from-cyan-200 via-sky-300 to-indigo-400 overflow-hidden" data-id="element-4183" data-mp="44jtwq66sgoc">
        {/* Background: Diamond facets */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4184" data-mp="3m9n7kza7y10d">
          <circle cx="100" cy="95" r="80" fill="#CFFAFE" opacity="0.4" data-id="element-4185" data-mp="2au889oujex23" />
          <g transform="translate(100, 95)" opacity="0.5" data-id="element-4186" data-mp="2fum7che5uwnz">
            {[...Array(6)].map((_, i) => <path key={i} d="M0 0 L0 -70" stroke="#FFFFFF" strokeWidth="2" transform={`rotate(${i * 60})`} data-id="element-4187" data-mp="b8126mfbjssw" data-mpi={i} />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4188" data-mp="l4mb3iuglo20">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-4189" data-mp="g9yqhv2ktdsp">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4190" data-mp="u63uba35y5ux" />
          </div>
        </div>

        {/* Foreground: Diamond + "25" */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4191" data-mp="1dwpgwwrnieod">
            <g transform="translate(100, 34)" data-id="element-4192" data-mp="1g12hjgwhqhqr">
              <path d="M-16 -4 L-8 -12 L8 -12 L16 -4 L0 14 Z" fill="#67E8F9" stroke="#0E7490" strokeWidth="1.5" data-id="element-4193" data-mp="1kyubshklyfy4" />
              <path d="M-16 -4 L16 -4" stroke="#0E7490" strokeWidth="1" data-id="element-4194" data-mp="1pw4bqr5mia07" />
            </g>
            <path d="M-10 152 Q100 178 210 152 L210 200 L-10 200 Z" fill="#3730A3" opacity="0.82" data-id="element-4195" data-mp="1uqqiui4o9geh" />
            <text x="100" y="184" textAnchor="middle" fontFamily="sans-serif" fontSize="18" fontWeight="900" fill="#A5F3FC" data-id="element-4196" data-mp="23oap65he62vy">
              25 perfect
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}